"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserInfoAvatar = void 0;
const react_1 = __importDefault(require("react"));
require("./index.scss");
const AvatarComponent_1 = __importDefault(require("@Components/AvatarComponent"));
const Tag_1 = require("@Components/Tag");
const UserInfoAvatar = (props) => {
    const { firstName, lastName, groups, email, verificationStatus } = props.userInfo;
    return (react_1.default.createElement("div", { className: `user-info-avatar-component` },
        react_1.default.createElement(AvatarComponent_1.default, { firstName: firstName ? firstName : 'NoData', lastName: lastName ? lastName : 'NoData' }),
        react_1.default.createElement("div", { className: 'info' },
            react_1.default.createElement("h5", { title: firstName + ' ' + lastName },
                firstName,
                " ",
                lastName),
            groups && groups.length ? (react_1.default.createElement("div", { className: 'tags' }, groups &&
                groups.map((item) => (react_1.default.createElement(Tag_1.TagComponent, { key: item.name, type: 'primary', name: item.name }))))) : null,
            react_1.default.createElement("div", null,
                email ? (react_1.default.createElement("p", { className: 'small' },
                    "Email: ",
                    react_1.default.createElement("span", null, email))) : null,
                verificationStatus ? (react_1.default.createElement("p", { className: 'small' },
                    "Status: ",
                    react_1.default.createElement("span", null, verificationStatus))) : null))));
};
exports.UserInfoAvatar = UserInfoAvatar;
